module.exports = __webpack_public_path__ + "media/images/front/not-logged-in-lp-renew/img_webinar_03-180d889066c8af238aa866e3dc5e35b8.png";